<template>
  <div class="flex w-full h-full justify-end">
    <button class="flex items-center" @click.prevent.stop="handlePreview">
      <icon :icon="mdiEye" :size="IconSize.SM" />
    </button>
  </div>
</template>

<script>
import { mdiEye } from '@mdi/js';
import { Icon, IconSize } from '@/components/Icon';

export default {
  name: 'SurveyPreviewCell',
  components: {
    Icon,
  },
  data() {
    return {
      IconSize,
    };
  },
  methods: {
    handlePreview() {
      this.params.onPreview(this.params.data);
    },
  },
  setup() {
    return {
      mdiEye,
    };
  },
};
</script>
